import {
  GET_USER_CONVERSATION_START,
  GET_USER_CONVERSATION_SUCCESS,
  GET_USER_CONVERSATION_FAIL,
  SET_DISPLAY_CHAT,
  SET_SELECTED_CONVERSATION,
  SET_CONVERSATIONS,
  SET_DISPLAY_CUSTOMER_DETAILS,
  DELETE_CONVERSATION_START,
  DELETE_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION_FAIL,
  LOGOUT_FAIL,
  LOGOUT_SUCCESS,
  LOGOUT_START,
  REGISTER_FAIL,
  REGISTER_START,
  REGISTER_SUCCESS,
  SET_CONSTANT_CONVERSATION,
  SET_SELECTED_USER_CUSTOMERS,
  UPDATE_USER_FAIL,
  UPDATE_USER_START,
  UPDATE_USER_SUCCESS,
  SHOW_FILE_UPLOAD,
  SET_USER_VERIFICATION,
  PATCH_USER_START,
  PATCH_USER_SUCCESS,
  PATCH_USER_FAIL,
  UPDATE_CONVERSATIONS_START,
  UPDATE_CONVERSATIONS_SUCCESS,
  UPDATE_CONVERSATIONS_FAIL,
  MARK_CUSTOMER_MESSAGES_AS_READ,
  ARCHIVED_CONVERSATIONS_SUCCESS,
  ADD_CONVERSATION_SUCCESS,
  SELECTED_CONVERSATION_CHAT,
  UPDATE_GROUP_SELECTED_CONVERSATION_MEMBERS,
  UPDATE_CONVERSATION_MEDIA,
  UPDATE_CONVERSATION_DOCS,
  UPDATE_CONVERSATION_LINKS,
  GET_CONVERSATION_MEDIA_START,
  GET_CONVERSATION_MEDIA_FAIL,
  SET_MESSAGE_ID,
  SET_CONVERSATION_DATA,
} from "./constants";

const updateSelectedConversationChat = (messages, direction, emptyChat) => ({
  type: SELECTED_CONVERSATION_CHAT,
  messages,
  direction,
  emptyChat,
});

const getUserConversationStartAction = () => ({
  type: GET_USER_CONVERSATION_START,
});

const getUserConversationSuccessAction = (userId, conversations, action) => ({
  type: GET_USER_CONVERSATION_SUCCESS,
  userId,
  conversations,
  action,
});

const getUserConversationFailAction = (errorMsg) => ({
  type: GET_USER_CONVERSATION_FAIL,
  errorMsg,
});

const setDisplayChatAction = (value) => ({
  type: SET_DISPLAY_CHAT,
  value,
});

const setConversationsAction = (conversations) => ({
  type: SET_CONVERSATIONS,
  conversations,
});

const setConstantConversationsAction = (constantConversations) => ({
  type: SET_CONSTANT_CONVERSATION,
  constantConversations,
});

const setSelectedConversationAction = (selectedConversation) => ({
  type: SET_SELECTED_CONVERSATION,
  selectedConversation,
});

const setDisplayCustomerDataAction = (value) => ({
  type: SET_DISPLAY_CUSTOMER_DETAILS,
  value,
});

const deleteConversationStartAction = () => ({
  type: DELETE_CONVERSATION_START,
});

const deleteConversationSuccessAction = (selectedConversation) => ({
  type: DELETE_CONVERSATION_SUCCESS,
  selectedConversation,
});

const logoutStartAction = () => ({
  type: LOGOUT_START,
});

const logoutSuccessAction = () => ({
  type: LOGOUT_SUCCESS,
});

const logoutFailAction = (errorMsg) => ({
  type: LOGOUT_FAIL,
  errorMsg,
});

const deleteConversationFailAction = () => ({
  type: DELETE_CONVERSATION_FAIL,
});

const registerStartAction = () => ({
  type: REGISTER_START,
});

const registerSuccessAction = () => ({
  type: REGISTER_SUCCESS,
});

const registerFailAction = (errorMsg) => ({
  type: REGISTER_FAIL,
  errorMsg,
});

const setSelectedUserCustomersAction = (selectedUserCustomer) => ({
  type: SET_SELECTED_USER_CUSTOMERS,
  selectedUserCustomer,
});

const updateUserStartAction = () => ({
  type: UPDATE_USER_START,
});

const updateUserSuccessAction = (updatedUser) => ({
  type: UPDATE_USER_SUCCESS,
  updatedUser,
});

const updateUserFailAction = (updateUserErrorMsg) => ({
  type: UPDATE_USER_FAIL,
  updateUserErrorMsg,
});

const showFileUploadAction = (showFileUpload) => ({
  type: SHOW_FILE_UPLOAD,
  showFileUpload,
});

const setUserVerificationAction = (isUserVerified) => ({
  type: SET_USER_VERIFICATION,
  isUserVerified,
});

const patchUserStartAction = (patchErrorMsg) => ({
  type: PATCH_USER_START,
  patchErrorMsg,
});

const patchUserSuccessAction = (value) => ({
  type: PATCH_USER_SUCCESS,
  ...value,
});

const patchUserFailAction = () => ({
  type: PATCH_USER_FAIL,
});

const updateConversationsStart = () => ({
  type: UPDATE_CONVERSATIONS_START,
});

const addConversationSuccess = (message, userId, userData, lastMsgId) => ({
  type: ADD_CONVERSATION_SUCCESS,
  message,
  userId,
  userData,
  lastMsgId,
});

const UpdateConversationMedia = (conversation_id, media) => ({
  type: UPDATE_CONVERSATION_MEDIA,
  conversation_id,
  media,
});

const UpdateConversationDocs = (conversation_id, docs) => ({
  type: UPDATE_CONVERSATION_DOCS,
  conversation_id,
  docs,
});

const UpdateConversationLinks = (conversation_id, links) => ({
  type: UPDATE_CONVERSATION_LINKS,
  conversation_id,
  links,
});

const updateConversationsSuccess = (
  message,
  allContacts,
  setArchived,
  setPinned,
  setRead,
  userId,
  sendMsgFromArchivedChat,
  setExitGroup,
  clearChat,
  setGroupChatClosed,
  newGroupName,
  privacy,
  updatedGroupMembers,
  updatedJoinRequests,
  setMute,
  newGroupAvatar,
  setBlocked,
) => ({
  type: UPDATE_CONVERSATIONS_SUCCESS,
  message,
  allContacts,
  setArchived,
  setPinned,
  setRead,
  userId,
  sendMsgFromArchivedChat,
  setExitGroup,
  clearChat,
  setGroupChatClosed,
  newGroupName,
  privacy,
  updatedGroupMembers,
  updatedJoinRequests,
  setMute,
  newGroupAvatar,
  setBlocked,
});

const updateConversationsFail = (errorMsg) => ({
  type: UPDATE_CONVERSATIONS_FAIL,
  errorMsg,
});

const markCustomerMessagesAsReadAction = (conversation_id, userId) => ({
  type: MARK_CUSTOMER_MESSAGES_AS_READ,
  conversation_id,
  userId,
});

const getArchivedConversationsSuccess = (archivedConversations) => ({
  type: ARCHIVED_CONVERSATIONS_SUCCESS,
  archivedConversations,
});

const updateGroupConversationMembers = (members, updatedCoAdmins) => ({
  type: UPDATE_GROUP_SELECTED_CONVERSATION_MEMBERS,
  members,
  updatedCoAdmins,
});

const getConversationMediaStartAction = () => ({
  type: GET_CONVERSATION_MEDIA_START,
});

const getConversationMediaFailAction = (error) => ({
  type: GET_CONVERSATION_MEDIA_FAIL,
  error,
});

const setMessageId = (messageId) => ({
  type: SET_MESSAGE_ID,
  messageId,
});

const setConversationData = (conversationId, customerUserId) => ({
  type: SET_CONVERSATION_DATA,
  payload: { conversationId, customerUserId },
});

export {
  getConversationMediaStartAction,
  getConversationMediaFailAction,
  UpdateConversationDocs,
  UpdateConversationLinks,
  updateGroupConversationMembers,
  updateSelectedConversationChat,
  getArchivedConversationsSuccess,
  markCustomerMessagesAsReadAction,
  updateConversationsStart,
  updateConversationsSuccess,
  updateConversationsFail,
  patchUserStartAction,
  patchUserSuccessAction,
  patchUserFailAction,
  setUserVerificationAction,
  updateUserStartAction,
  updateUserSuccessAction,
  updateUserFailAction,
  registerStartAction,
  registerSuccessAction,
  registerFailAction,
  getUserConversationStartAction,
  getUserConversationSuccessAction,
  getUserConversationFailAction,
  setDisplayChatAction,
  setConversationsAction,
  setSelectedConversationAction,
  setDisplayCustomerDataAction,
  deleteConversationStartAction,
  deleteConversationSuccessAction,
  deleteConversationFailAction,
  logoutStartAction,
  logoutSuccessAction,
  logoutFailAction,
  setSelectedUserCustomersAction,
  setConstantConversationsAction,
  showFileUploadAction,
  addConversationSuccess,
  UpdateConversationMedia,
  setMessageId,
  setConversationData,
};
